import { Plan } from "../Plan/PlanModel";

export type SoulSubmissionSource =
  "soul_submissions" | "questionnaire_submissions";

export type SoulFormSubmission = {
  id: string;
  json: any;
  finishedAt: string | null;
  updatedAt: string | null;
  submittedAt: string | null;
  status?: string | null;
  source?: SoulSubmissionSource;
};

export type SoulQuestionnaireForm = {
  questionnaire: {
    id: string;
    code: string;
    name: string;
    description?: string | null;
  };
  submission: SoulFormSubmission | null;
  latestForm: {
    id: string;
    json: any;
    createdAt: Date | string;
  };
};

export class SoulDataModel {
  userId?: string;
  recordType?: "soul" | "email_preview";
  previewId?: number | null;
  rowKey?: string;
  email?: string | null;
  fullName?: string;
  role?: string;
  plan?: Plan;
  documentType?: string;
  passport?: string | null;
  address?: string;
  birthDate?: string;
  isParentAccount?: boolean;
  createdAt?: string;
  submission?: SoulFormSubmission;
  latestForm?: {
    id: string;
    json: any;
    createdAt: Date;
  };
  questionnaireForms?: SoulQuestionnaireForm[];

  constructor(data: any) {
    data = data ?? {};
    this.questionnaireForms = [];
    this.recordType = data?.recordType || "soul";
    this.previewId = data?.previewId ?? null;
    this.rowKey =
      this.recordType === "email_preview"
        ? `email_preview:${this.previewId ?? data?.email ?? ""}`
        : `soul:${data?.userId ?? ""}`;
    this.fullName = data?.fullName || "Anónimo";
    this.role = data?.role;
    this.documentType = data?.documentType;
    this.passport = data?.passport ?? null;
    this.address = data?.address;
    this.email = data?.email ?? null;
    this.birthDate = data?.birthDate;
    this.isParentAccount = data?.isParentAccount || false;
    this.plan = data?.plan;
    this.userId = data?.userId;
    this.createdAt = data?.createdAt?.toString();
    if (data?.submission) {
      const sub = data.submission;
      this.submission = {
        id: sub.id || null,
        json: sub.json || null,
        finishedAt: sub.finishedAt || null,
        updatedAt: sub.updatedAt || null,
        submittedAt: sub.submittedAt || null,
        status: sub.status || null,
        source: sub.source || undefined,
      };
    }
    if (data?.latestForm) {
      const lf = data.latestForm;
      this.latestForm = {
        id: lf.id,
        json: lf.json || null,
        createdAt: lf.createdAt,
      };
    }
    if (Array.isArray(data?.questionnaireForms)) {
      this.questionnaireForms = data.questionnaireForms.map((item: any) => ({
        questionnaire: {
          id: item.questionnaire?.id,
          code: item.questionnaire?.code,
          name: item.questionnaire?.name,
          description: item.questionnaire?.description ?? null,
        },
        submission: item.submission
          ? {
              id: item.submission.id || null,
              json: item.submission.json || null,
              finishedAt: item.submission.finishedAt || null,
              updatedAt: item.submission.updatedAt || null,
              submittedAt: item.submission.submittedAt || null,
              status: item.submission.status || null,
              source: item.submission.source || undefined,
            }
          : null,
        latestForm: {
          id: item.latestForm?.id,
          json: item.latestForm?.json || null,
          createdAt: item.latestForm?.createdAt,
        },
      }));
    }
  }
}

export class UpdateSoulInfoPayload {
  payload?: SoulDataModel;
  submissionId?: string;

  constructor(payload?: SoulDataModel, submissionId?: string) {
    this.payload = payload;
    this.submissionId = submissionId;
  }
}

export type DeleteAdminUserPayload = {
  recordType: "soul" | "email_preview";
  userId?: string;
  previewId?: number | null;
  confirmDeletion?: boolean;
};
